/** @format */

export const BoolTranslateHelper = (value?: boolean | null): string => {
    let translate = 'general:common.no';
    if (value) {
        translate = 'general:common.yes';
    }
    return translate;
};

export const BoolTranslateTrueFalseHelper = (value?: boolean | null): string => {
    let translate = 'general:common.false';
    if (value) {
        translate = 'general:common.true';
    }
    return translate;
};
